module.exports = __webpack_public_path__ + "img/baggage.e3d85e67.png";